/* eslint-disable */

import { type SVGProps } from "react";
import { cn } from "../../lib/utils";

export function Gmail({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn("w-[1em] h-[1em]", className)}
      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      
<path d="M2.23909 13.3333H4.36031V8.18178L1.33 5.90906V12.4242C1.33 12.9272 1.73758 13.3333 2.23909 13.3333Z" fill="#4285F4"></path>
<path d="M11.6329 13.3333H13.7541C14.2572 13.3333 14.6632 12.9257 14.6632 12.4242V5.90906L11.6329 8.18178" fill="#34A853"></path>
<path d="M11.6329 4.24242V8.18181L14.6632 5.90909V4.69696C14.6632 3.57272 13.38 2.93181 12.4815 3.60606" fill="#FBBC04"></path>
<path d="M4.36028 8.18183V4.24243L7.99664 6.9697L11.633 4.24243V8.18183L7.99664 10.9091" fill="#EA4335"></path>
<path d="M1.33 4.69696V5.90909L4.36031 8.18181V4.24242L3.51182 3.60606C2.61182 2.93181 1.33 3.57272 1.33 4.69696Z" fill="#C5221F"></path>

    </svg>
  );
}
